import React, { Component } from "react";
import DtApiUtil from "../../../utils/DtApiUtil";
import Global from "../../../Global";

class FooterContact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userLoginIdDT: null,
    };
  }

  componentWillMount = async () => {
    const userLoginIdDT = await this.getUserLoginIdDT();
    this.setState({ userLoginIdDT });
  };

  getUserLoginIdDT = async () => {
    const cookieName = "BTkPFJMohHNmRD";
    const cookieProfile = Global.getCookie(cookieName);
    let isLoggedInBAU = cookieProfile.length > 0;
    if (isLoggedInBAU) return null;

    let loginStatusResponse = await DtApiUtil.userGetLoginStatus();
    if (loginStatusResponse.status !== 200) return null;

    let loginStatusResult = await DtApiUtil.getLoginStatusResult(
      loginStatusResponse
    );
    return loginStatusResult.displayName;
  };

  getFooterContactHTML() {
    const { items } = this.props.data;
    const { userLoginIdDT } = this.state;
    const lang = window.THREE_REACT_APP_GLOBAL.language;

    let html = items.map((item, index) => {
      var url = item.href;
      if (
        (item.alt.toLowerCase().includes("3ichat") ||
          item.src.toLowerCase().includes("3ichat")) &&
        userLoginIdDT != null &&
        userLoginIdDT.length > 0
      ) {
        url = `${
          process.env.REACT_APP_DT_POSTPAID_BASE_URL
        }/${lang}/account/purchase?popup=login&id=${userLoginIdDT}&isFrom3iChat=true`;
      }

      return (
        <li key={index}>
          <span className="footer-icon">
            <img src={item.src} alt={item.alt} />
          </span>
          <a href={url}>{item.label}</a>
        </li>
      );
    });

    return <ul>{html}</ul>;
  }

  render() {
    return (
      <div className="col col-xs-12 col-md-4 col-footer-contact">
        <h6>{this.props.data.title}</h6>
        {this.getFooterContactHTML()}
      </div>
    );
  }
}

export default FooterContact;
